import type { HTMLAttributes } from 'react'
import { tv, type VariantProps } from 'tailwind-variants'

import { Avatar, AvatarFallback, AvatarImage } from '@/components/avatar'
import { Skeleton } from '@/components/skeleton'

const card = tv({
  base: 'p-6 h-36 flex rounded-lg gap-5',
  variants: {
    variant: {
      news: 'bg-bios-overlay-100 text-publication-news',
      letters: 'bg-bios-overlay-200 text-bios-500',
    },
  },
})

interface CardProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof card> {
  img: string
  title: string
  subTitle: string
}

export function Card({
  variant,
  className,
  title,
  subTitle,
  img,
  ...props
}: CardProps) {
  return (
    <div {...props} className={card({ variant, className })}>
      {img !== '' && (
        <Avatar className="aspect-square h-full w-full max-w-24 rounded-none">
          <AvatarFallback>
            <Skeleton className="h-full w-full" />
          </AvatarFallback>
          <AvatarImage
            src={img}
            alt=""
            className="h-full w-full object-cover"
          />
        </Avatar>
      )}
      <div className="flex flex-1 flex-col gap-1 lg:gap-3 2xl:gap-6">
        <h1 className="line-clamp-1 text-lg font-bold lg:text-2xl">{title}</h1>
        <p className="text-monochromatic-500 line-clamp-2">{subTitle}</p>
      </div>
    </div>
  )
}
